<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            v-model="zendai.show"
            @hidden="clearZendai" 
            size="lg"
            hide-footer
        >
        <template slot="modal-title">
            <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-12">
                    <h3 class="mb-0">เส้นด้าย - Zendai
                        <small><a :href="linkManual" target="_blank" class="px-1">
                            คู่มือขั้นตอนการทำรายการบริจาคให้เส้นด้าย
                        </a></small>
                    </h3>
                </div>
            </div>
            </div>
        </template>
        <card shadow type="secondary" class="m--4">
            <template v-if="switchModal === 'condition'">
                <form @submit.prevent>
                    <div class="row">
                        <div class="col-lg-12">
                            <ModalConditionZendai />
                            <div class="mt-4 w-100 text-center">
                                <div class="pb-4">
                                    <b-form-checkbox
                                        v-model="status"
                                        :value="true"
                                        :unchecked-value="false"
                                    >
                                        ฉันยอมรับ <u>นโยบายความเป็นส่วนตัว</u> และ <u>ข้อกำหนดและเงื่อนไข</u>
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4 w-100 text-right">
                        <b-button variant="secondary" @click="clearZendai">ปิด</b-button>
                        <b-button type="submit" variant="success" :disabled="!status" @click="switchModal = 'selectItem'">ยืนยัน</b-button>
                    </div>
                </form>
            </template>
            <template v-else-if="switchModal === 'selectItem'">
                <div class="row">
                    <div class="col-lg-12">
                        <b-table
                            :items="itemZendai"
                            :fields="fieldsZendai"
                            responsive
                            class="scroll-bar-pop"
                        >
                            <template slot="name" slot-scope="row">
                                <span class="text-newline">{{row.item.name}}</span>
                            </template>
                            <template slot="quantity" slot-scope="row">
                                <number-input
                                    size="small"
                                    @change="culculateItem(row.item , row.index)"
                                    v-model="row.item.quantity"
                                    :min="0"
                                    inline
                                    controls
                                    class="input-product-table"
                                ></number-input>
                            </template>
                            <template slot="price" slot-scope="row">
                                {{ row.item.price | numFormat('0,0.00')}}
                                <span> / {{row.item.unit}}</span>
                            </template>
                            <template slot="total" slot-scope="row">
                                {{ row.item.total | numFormat('0,0.00')}}
                            </template>
                                
                        </b-table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="group-result">
                            <div class="price">
                                <h6>ราคารวม</h6>
                                <h1>
                                    {{totalZendai | numFormat('0,0.00')}}
                                <small>บาท</small>
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-4 w-100 text-right">
                    <b-button variant="secondary" @click="clearZendai">ยกเลิก</b-button>
                    <b-button type="submit" variant="success" :disabled="totalZendai == 0" @click="switchModal = 'pay' , showQrCode()">ยืนยัน</b-button>
                </div>
            </template>
            <template v-else>
                <div class="row">
                    <div class="col-lg-12 px-lg-5 py-lg-5 text-center">
                        <ShowQrCode 
                            :loadQrCode="loadQrCode"
                            :linkQrCode="qrCode" 
                            :hasBrowser="true" 
                            :linkBrowser="googleFormZendai()" 
                        />
                        <div class="mt-4 w-100 text-center">
                            <div class="pb-4">
                                <b-form-checkbox
                                    v-model="statusScan"
                                    :value="true"
                                    :unchecked-value="false"
                                >
                                    ฉันยืนยัน <u>การทำรายการ</u> และ <u>แนบสลิปการโอนเงินเรียบร้อยแล้ว</u>
                                </b-form-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="mt-4 w-100 text-right">
                    <b-button variant="secondary" @click="clearZendai">ปิด</b-button>
                    <b-button type="submit" variant="success" :disabled="!statusScan" @click="createZendai()">ยืนยัน</b-button>
                </div>
            </template>
        </card>
        </b-modal>
    </div>
</template>
<script>
import ShowQrCode from '@/components/ShowQrCode'
import ModalConditionZendai from '@/components/Modals/ModalConditionZendai'
import { getQrCode } from "@/axios/qrCode.js"

export default {
    name: "ModalZendai" ,
    props: {
        zendai: Object,
        sender: Object
    },
    components:{
        ShowQrCode,
        ModalConditionZendai
    },
    data() {
        return {
            status: false,
            statusScan: false,
            loadQrCode: false,
            switchModal: 'condition',
            itemZendai: [],
            entryGoogle:{
                '1':'83560894',
                '2':'1073195733',
                '3':'1486516177',
                '4':'80238519',
                '5':'1876029950',
                '6':'1417795855',
                '7':'307371607',              
            },
            qrCode: '',
            linkManual: 'https://docs.google.com/presentation/d/12h-lXPsG_8nt9Z2jH-PBUADDR4KRSuV6kGIp_0lKiKA/edit?usp=sharing'
        }
    },
    mounted() {
        this.setDefaultItem()
    },
    methods: {
        clearZendai(){
            this.status = false
            this.statusScan = false
            this.switchModal = 'condition'
            this.zendai.zendai.rate = 0;
            this.loadQrCode = false
            this.qrCode = '';
            this.setDefaultItem()
            this.zendai.show = false
        },
        setDefaultItem(){
            this.itemZendai = this.defaultItemZendai()
        },
        createZendai(){
            this.zendai.rate = this.totalZendai
            this.$emit('addZendai')
        },
        culculateItem(item , index) { 
            this.$set(this.itemZendai[index] , 'total' , item.quantity * item.price)           
        },
        googleFormZendai(){
            let entryItem = [];
            
            this.itemZendai.forEach(item => {
                entryItem.push(`&entry.${this.entryGoogle[item.id]}=${item.quantity}`)
            });
            return `https://docs.google.com/forms/d/e/1FAIpQLScCiVbNvhpLBZyg0eNyxlJRBegSrRwCTFUunFZW4SndrRCRXg/viewform?usp=pp_url&entry.64677128=${this.$USER_LOGIN.get().details.shop_code}&entry.1739116608=${this.sender.name}&entry.840254708=
                    ${entryItem.join('')}`
        },
        showQrCode(){
            this.loadQrCode = true
            getQrCode(200 , this.googleFormZendai()).then( response => {
               this.qrCode = response
               this.loadQrCode = false
            })
            // return `${this.$API_URL}/qrcode?size=200&text=${this.googleFormZendai()}`
        },
        defaultItemZendai(){
            return [
                {
                    id: 1,
                    name: 'ข้าวกล่องสำหรับคนกักตัวและเดือดร้อน',
                    price: 25,
                    unit: 'กล่อง',
                    quantity: 0,
                    total: 0
                },
                {
                    id: 2,
                    name: 'ข้าวกล่องสำหรับอาสาสมัคร',
                    price: 25,
                    unit: 'กล่อง',
                    quantity: 0,
                    total: 0
                },
                {
                    id: 3,
                    name: 'ข้าวสารสำหรับคนกักตัวและเดือดร้อน',
                    price: 150,
                    unit: 'ถุง',
                    quantity: 0,
                    total: 0
                },
                {
                    id: 4,
                    name: 'อุปกรณ์ป้องกันเชื้อโควิดต่อการปฏิบัติงาน',
                    price: 300,
                    unit: 'ครั้ง',
                    quantity: 0,
                    total: 0
                },
                {
                    id: 5,
                    name: 'ถุงกักตัว ชุดเล็ก (ข้าว 5 กก./ปลากระป๋อง 5 กระป๋อง/มาม่า 10 ซอง)',
                    price: 300,
                    unit: 'ชุด',
                    quantity: 0,
                    total: 0
                },
                {
                    id: 6,
                    name: 'ถุงกักตัว ชุดใหญ่ (ข้าว 5 กก./ปลากระป๋อง 5 กระป๋อง/มาม่า 10 ซอง/ผงซักฟอก/สบู่/ยาสีฟัน/ยาสระผม)',
                    price: 600,
                    unit: 'ชุด',
                    quantity: 0,
                    total: 0
                },
                {
                    id: 7,
                    name: 'รถรับ-ส่งเพื่อตรวจหาเชื้อโควิด/ไปรักษา',
                    price: 1000,
                    unit: 'เที่ยว',
                    quantity: 0,
                    total: 0
                },
            ]
        }
    },
    computed: {
        fieldsZendai(){
            let fields = [
                { key: "name", label: "ชื่อสินค้า" },
                { key: "quantity", label: "จำนวน" },
                { key: "price", label: "ราคา" },
                { key: "total", label: "ราคารวม" },
            ]
            return fields
        },
        totalZendai() {
            return this.itemZendai.reduce((total, item) => {
                return total + ( Number(item.quantity) * Number(item.price) )
            }, 0);
        },
    }
}
</script>